import { useTranslation } from 'react-i18next';

export interface Barra {
  clave: string;
  etiqueta: string;
  valor: number;
}

/**
 * Comparación de magnitud entre categorías con nombre: barras horizontales.
 *
 * Una sola serie, así que una sola hue y sin leyenda — el título dice qué se está
 * midiendo. Cada barra lleva su cifra escrita al lado: la identidad del dato nunca
 * depende de distinguir un color.
 */
export function BarrasComparativas({ datos, unidad }: { datos: Barra[]; unidad: string }) {
  const { t } = useTranslation();
  const maximo = Math.max(1, ...datos.map((d) => d.valor));

  if (datos.length === 0) {
    return <p className="vacio">{t('chart.noData')}</p>;
  }

  return (
    <div className="barras" role="img" aria-label={`${unidad}: ${datos.map((d) => `${d.etiqueta} ${d.valor}`).join(', ')}`}>
      {datos.map((dato) => (
        <div className="barra" key={dato.clave} title={`${dato.etiqueta}: ${dato.valor} ${unidad}`}>
          <span className="barra__etiqueta">{dato.etiqueta}</span>
          <div className="barra__pista">
            <div className="barra__valor" style={{ width: `${(dato.valor / maximo) * 100}%` }} />
          </div>
          <span className="barra__cifra">{dato.valor}</span>
        </div>
      ))}
    </div>
  );
}
